"use client";

import { Col, Row } from "antd";
import Text from "../../common/Typography/Text";
import Title from "../../common/Typography/Title";
import { useTranslation } from "react-i18next";
import NewsItemSkeleton from "./NewsItem.skeleton";

const NewsSectionSkeleton = () => {
  const { t } = useTranslation()

  return (
    <Col span={24} className="home__news">
      <Row justify="space-between" align="middle">
        <Col>
          <Title
            level={3}
            style={{
              margin: 0,
            }}
          >
            {t("home.section_news_title")}
          </Title>
        </Col>
      </Row>

      <Row>
        <Text type="secondary" style={{ marginBottom: "2rem" }}>
          {t("home.section_news_desc")}
        </Text>
      </Row>

      <Row gutter={[15, 15]}>
        {[1, 2, 3, 4].map((idx) => (
          <Col className="home__news--item skeleton" key={idx} xs={24} sm={12} md={8} lg={6}>
            <NewsItemSkeleton />
          </Col>
        ))}
      </Row>
    </Col>
  );
};

export default NewsSectionSkeleton;
